import handleNaN from './handleNaN';

const calculatePercentage = (partial: number, total: number): number => {
  const safePartial = handleNaN(partial);
  const safeTotal = handleNaN(total);

  return safeTotal === 0 ? 0 : safePartial / safeTotal;
};

export default calculatePercentage;
